(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pluff-info-bar"] && !Shopify.designMode) return;
  try {
    
  class PluffInfoBar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.pluff-info-bar__benefits > li'));
      if (this.items.length < 2) return;

      this.index = Math.max(
        0,
        this.items.findIndex((item) => item.classList.contains('is-active'))
      );
      this.mq = window.matchMedia('(max-width: 749px)');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;

      this.onBreakpoint = () => this.sync();
      this.onVisibility = () => this.sync();
      this.pause = () => {
        this.paused = true;
        this.stop();
      };
      this.resume = () => {
        this.paused = false;
        this.sync();
      };

      this.mq.addEventListener('change', this.onBreakpoint);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.resume);
      if (window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('pointerenter', this.pause);
        this.addEventListener('pointerleave', this.resume);
      }
      this.sync();
    }

    disconnectedCallback() {
      this.stop();
      this.mq?.removeEventListener('change', this.onBreakpoint);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.removeEventListener('pointerenter', this.pause);
      this.removeEventListener('pointerleave', this.resume);
      this.removeEventListener('focusin', this.pause);
      this.removeEventListener('focusout', this.resume);
    }

    applyActive() {
      this.items.forEach((item, i) => {
        const active = i === this.index;
        item.classList.toggle('is-active', active);
        if (this.mq.matches) {
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
        } else {
          item.removeAttribute('aria-hidden');
        }
      });
    }

    sync() {
      this.applyActive();
      if (this.mq.matches && !this.paused && document.visibilityState === 'visible') {
        this.start();
        return;
      }
      this.stop();
    }

    start() {
      this.stop();
      const delay = this.reduceMotion.matches ? 5000 : 3200;
      this.timer = setInterval(() => this.next(), delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      this.index = (this.index + 1) % this.items.length;
      this.applyActive();
    }
  }

  if (!customElements.get('pluff-info-bar')) {
    customElements.define('pluff-info-bar', PluffInfoBar);
  }

  } catch(e) { console.error(e); }
})();
})();
